export default {
  title: 'Tervetuloa',
  subtitle: 'Kirjaudu sisään hallitaksesi tiliäsi ja tilauksiasi',
  benefits: {
    earn_points: {
      title: 'Kerää pisteitä jokaisesta tilauksesta',
      description: 'Kerää pisteitä ja avaa eksklusiivisia etuja',
    },
    get_deals: {
      title: 'Saat erikoisalennuksia',
      description: 'Käytä pisteitäsi ilmaisten tuotteiden hankkimiseen',
    },
    redeem_points: {
      title: 'Lunasta pisteitä ilmaiseksi ruoaksi',
      description: 'Saat pääsyn vain jäsenille tarkoitettuihin tarjouksiin',
    },
  },
};
